import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { FcKindle } from "react-icons/fc";
import { useNavigate } from "react-router-dom";

export const SubmenuRaporPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setAppBar({ title: "Nilai", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Nilai",
    });
  }, [setHeader]);
  return (
    <div className="tw-p-4 tw-pb-0 menu">
      <div className="card-body-grid">
        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.DAILY_REPORT_CARD)}
            className="tw-m-0"
          >
            <FcKindle className="card-icon" style={{ background: "#eee" }} />
            <div className="tw-mt-0 card-name">Nilai Harian</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.FINAL_EXAM_REPORT_CARD)}
            className="tw-m-0"
          >
            <FcKindle className="card-icon" style={{ background: "#eee" }} />
            <div className="tw-mt-0 card-name">Nilai Ujian Semester</div>
          </div>
        </div>

        <div className="card-grid">
          <div onClick={() => navigate(linkPage.SULUK_PAGE)} className="tw-m-0">
            <FcKindle className="card-icon" style={{ background: "#eee" }} />
            <div className="tw-mt-0 card-name">Rekap Suluk</div>
          </div>
        </div>

        {/* <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.FINAL_REPORT_CARD)}
            className="tw-m-0"
          >
            <FcKindle className="card-icon" style={{ background: "#eee" }} />
            <div className="tw-mt-0 card-name">Rapor</div>
          </div>
        </div> */}
      </div>
    </div>
  );
};
